"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("cross-fetch/polyfill");

var serviceUtils_1 = require("./serviceUtils");
/**
 * @ignore
 */


var Service =
/*#__PURE__*/
function () {
  function Service() {
    _classCallCheck(this, Service);
  }

  _createClass(Service, null, [{
    key: "validateProof",
    value: function validateProof(proof, ownerAddress) {
      var _this = this;

      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var proofUrl;
      return Promise.resolve().then(function () {
        proofUrl = _this.getProofUrl(proof);
        return fetch(proofUrl);
      }).then(function (res) {
        if (res.status !== 200) {
          throw new Error("Proof url ".concat(proofUrl, " returned unexpected http status ").concat(res.status, ".\n              Unable to validate proof."));
        }

        return res.text();
      }).then(function (text) {
        // Validate identity in provided proof body/tags if required
        if (_this.shouldValidateIdentityInBody() && proof.identifier !== _this.getProofIdentity(text)) {
          return proof;
        }

        var proofText = _this.getProofStatement(text);

        proof.valid = serviceUtils_1.containsValidProofStatement(proofText, name) || serviceUtils_1.containsValidAddressProofStatement(proofText, ownerAddress);
        return proof;
      }).catch(function (error) {
        console.error(error);
        proof.valid = false;
        return proof;
      });
    }
  }, {
    key: "getBaseUrls",
    value: function getBaseUrls() {
      return [];
    }
  }, {
    key: "getProofIdentity",
    value: function getProofIdentity(searchText) {
      return searchText;
    }
  }, {
    key: "getProofStatement",
    value: function getProofStatement(searchText) {
      return searchText;
    }
  }, {
    key: "shouldValidateIdentityInBody",
    value: function shouldValidateIdentityInBody() {
      return false;
    }
  }, {
    key: "prefixScheme",
    value: function prefixScheme(proofUrl) {
      if (!proofUrl.startsWith('https://') && !proofUrl.startsWith('http://')) {
        return "https://".concat(proofUrl);
      } else if (proofUrl.startsWith('http://')) {
        return proofUrl.replace('http://', 'https://');
      } else {
        return proofUrl;
      }
    }
  }, {
    key: "getProofUrl",
    value: function getProofUrl(proof) {
      var baseUrls = this.getBaseUrls();
      var proofUrl = proof.proof_url.toLowerCase();
      proofUrl = this.prefixScheme(proofUrl);

      for (var i = 0; i < baseUrls.length; i++) {
        var requiredPrefix = "".concat(baseUrls[i]).concat(proof.identifier).toLowerCase();

        if (proofUrl.startsWith(requiredPrefix)) {
          return proofUrl;
        }
      }

      throw new Error("Proof url ".concat(proof.proof_url, " is not valid for service ").concat(proof.service));
    }
  }]);

  return Service;
}();

exports.Service = Service;